import React, { FC, useMemo } from "react";
import { StyleProp, View, ViewStyle } from "react-native";
import { style as dividerStyle } from "./Divider.style";

interface DividerProps {
  readonly style?: StyleProp<ViewStyle>;
}

const Divider: FC<DividerProps> = ({ style: customStyle }) => {
  const style = useMemo(() => dividerStyle(), []);

  return <View style={[style.divider, customStyle]} />;
};

export { Divider };
